import { DeleteArtifactRequestSchema, DeleteArtifactResponseSchema } from './delete-artifact.schema';
/**
 * Delete Artifact Endpoint Contract
 * Deletes an artifact by ID
 */ export const deleteArtifactContract = {
    method: 'DELETE',
    path: '/api/v2/artifact/:id',
    description: 'Delete an artifact by ID',
    requestSchema: DeleteArtifactRequestSchema,
    responseSchema: DeleteArtifactResponseSchema,
    statusCodes: {
        success: 200,
        errors: {
            401: 'Unauthorized - user not authenticated',
            404: 'Artifact not found'
        }
    }
};

//# sourceMappingURL=delete-artifact.contract.js.map